import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Card, CardContent, CardMedia, Grid } from "@mui/material"
import { styled } from "@mui/material/styles"
import { flexRender } from "@tanstack/react-table"

export const StyledRootCard = styled(Card)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex"
  }
}))

export const StyledCardMedia = styled(CardMedia)(({ theme }) => ({
  minWidth: "100%",
  height: "170px",
  [theme.breakpoints.up("md")]: {
    minWidth: "35%",
    height: "auto"
  }
}))

export const StyledDetailsDiv = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minWidth: 0
}))

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  flex: "1 0 auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  [theme.breakpoints.up("md")]: {
    flexDirection: "column",
    display: "flex",
    minHeight: "325px",
    padding: "24px 36px"
  }
}))

export const StyledFlexGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "row",
    flexWrap: "wrap"
  }
}))

export const StyledFlexBox = styled(Box)(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.down("lg")]: {
    flexWrap: "wrap"
  }
}))

export const StyledSuccessFlexBox = styled(Box)(({ theme }) => ({
  padding: "8px",
  backgroundColor: (theme.palette as any).green["200"],
  borderRadius: "4px",
  border: `1px solid ${(theme.palette as any).success["700"]}`,
  display: "flex",
  [theme.breakpoints.down("lg")]: {
    flexWrap: "wrap"
  }
}))

const standardFontAwesomeStyle = {
  borderRadius: "25px",
  height: 12,
  width: 12,
  padding: 6
}

export const StyledSecondaryFontAwesomeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  color: (theme.palette as any).success[700]
}))

export const StyledWarningFontAwesomeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.warning["main"]
}))

export const StyledErrorFontAwesomeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  color: (theme.palette as any).error[600]
}))

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  color: (theme.palette as any).primary[700],
  marginRight: 8
}))
